import React from "react";
import { Button, FormControl, FormLabel, Table } from "react-bootstrap";
import Select2 from "react-select";
import { quoteSelectMenuStyles } from "./quote-select-styles";

const currency = (value) => Number(value || 0).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
});

export const QuoteProductsStep = ({
    selectedProducts,
    activeProducts,
    selectValue,
    selectOption,
    handleSelectChange,
    handleSelectOptionChange,
    handleChange,
    handleAddRowClick,
    handlerRemoveRowClick,
    total,
}) => (
    <div className="quote-step-content">
        <section className="quote-section product-builder" aria-labelledby="products-heading">
            <div className="section-heading">
                <div>
                    <span className="section-kicker">Products</span>
                    <h2 id="products-heading">Build the quote</h2>
                    <p>Search by part number. Available options and included accessories appear automatically.</p>
                </div>
                <Button variant="outline-primary" onClick={handleAddRowClick} className="add-product-button">
                    <i className="fa fa-plus" aria-hidden="true"></i> Add product
                </Button>
            </div>

            <div className="product-table-wrap">
                <Table responsive className="product-table">
                    <thead>
                        <tr>
                            <th>Part number</th>
                            <th>Description</th>
                            <th>Quantity</th>
                            <th>Unit price</th>
                            <th>Total</th>
                            <th><span className="sr-only">Actions</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedProducts.map((product, productIndex) => (
                            <React.Fragment key={`product-${productIndex}`}>
                                <tr className="product-main-row">
                                    <td className="product-code-cell" data-label="Part number">
                                <Select2
                                    inputId={`product-${productIndex}`}
                                    name="productList"
                                    onChange={(value) => handleSelectChange(value, productIndex)}
                                    placeholder="Search part numbers"
                                    value={selectValue[productIndex]}
                                    options={activeProducts && activeProducts.map((item) => ({ label: item.ProductCode, value: item }))}
                                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                    menuPosition="fixed"
                                    menuPlacement="auto"
                                    styles={quoteSelectMenuStyles}
                                />
                                    </td>
                                    <td data-label="Description">
                                <FormControl
                                    id={`description-${productIndex}`}
                                    as="textarea"
                                    name="productDescription"
                                    rows={2}
                                    onChange={(event) => handleChange(event, productIndex)}
                                    value={product.Discription ? product.Discription.replace(/<[^>]+>/g, "") : ""}
                                    placeholder="Product description"
                                />
                                    </td>
                                    <td className="quantity-cell" data-label="Quantity">
                                <FormControl
                                    id={`quantity-${productIndex}`}
                                    type="number"
                                    className="form-control"
                                    name="Quantity"
                                    required
                                    min="1"
                                    value={product.Quantity}
                                    onChange={(event) => handleChange(event, productIndex)}
                                />
                                    </td>
                                    <td className="money-cell" data-label="Unit price">{currency(product.ProductPrice)}</td>
                                    <td className="money-cell line-total-cell" data-label="Total">{currency(product.ProductPrice * product.Quantity)}</td>
                                    <td className="remove-cell">
                                        <Button
                                            variant="link"
                                            className="remove-product-button"
                                            onClick={(event) => handlerRemoveRowClick(event, productIndex)}
                                            aria-label={`Remove item ${productIndex + 1}`}>
                                            <i className="fa fa-times" aria-hidden="true"></i>
                                        </Button>
                                    </td>
                                </tr>

                                {product.availableOptions && product.availableOptions.length > 0 && (
                                    <tr className="product-detail-row">
                                        <td colSpan="6">
                                            <div className="product-options">
                                                <h3>Configure options</h3>
                                {product.availableOptions.map((categoryOption, optionIndex) => {
                                    const selected = product.SelectedOption && product.SelectedOption[optionIndex];
                                    return (
                                        <div className="product-option-row" key={`${categoryOption.label}-${optionIndex}`}>
                                            <div>
                                                <FormLabel htmlFor={`option-${productIndex}-${optionIndex}`}>{categoryOption.label}</FormLabel>
                                                <Select2
                                                    inputId={`option-${productIndex}-${optionIndex}`}
                                                    name="categoryOptionsList"
                                                    onChange={(value) => handleSelectOptionChange(value, optionIndex, productIndex)}
                                                    placeholder={`Select ${categoryOption.label}`}
                                                    value={selectOption[`${categoryOption.label} ${product.ProductCode}`]}
                                                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                                    menuPosition="fixed"
                                                    menuPlacement="auto"
                                                    styles={quoteSelectMenuStyles}
                                                    options={categoryOption.options.map((option) => ({
                                                        label: `${option.optionName} [${option.optionsDesc}]`,
                                                        value: option,
                                                        category: `${categoryOption.label} ${product.ProductCode}`,
                                                    }))}
                                                />
                                            </div>
                                            <span>{selected ? currency(selected.ProductPrice) : "Included or priced on selection"}</span>
                                        </div>
                                    );
                                })}
                                            </div>
                                        </td>
                                    </tr>
                                )}

                                {product.Childs && product.Childs.length > 0 && (
                                    <tr className="product-detail-row">
                                        <td colSpan="6">
                                            <div className="included-products">
                                                <h3>Included accessories</h3>
                                {product.Childs.map((child, childIndex) => (
                                    <div className="included-product" key={`${child.ProductCode}-${childIndex}`}>
                                        <div>
                                            <strong>{child.ProductCode}</strong>
                                            <FormControl
                                                as="textarea"
                                                name="productDescriptionChild"
                                                rows={1}
                                                onChange={(event) => handleChange(event, productIndex, childIndex)}
                                                value={child.ProductDescriptionShort || ""}
                                            />
                                        </div>
                                        <span>Qty {Number(child.Qty || 0) * Number(product.Quantity || 0)}</span>
                                    </div>
                                ))}
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </Table>
            </div>

            <div className="quote-total-bar">
                <span>Quote total</span>
                <strong>{currency(total)}</strong>
            </div>
        </section>
    </div>
);
